import CreatureName from './CreatureName';

export default CreatureName;
export { CreatureName };
